import { ActionInterface } from "../../../Interface/ActionInterface";
import Constants from "../../../Action/Constants";
import { EventInterface } from "../../../Entity/Entities/Event/EventInterface";

interface StateInterface {
  requests: {};
  requestsOutdated: boolean;
  notificationsEventsCount: string;
  unfinishedTasksEventsCount: string;
  activitiesEventsCount: string;
  reminders: EventInterface[];
};

const initialState: StateInterface = {
  requests: {},
  requestsOutdated: false,
  notificationsEventsCount: "",
  unfinishedTasksEventsCount: "",
  activitiesEventsCount: "",
  reminders: []
};

export const eventsReducer = (state: StateInterface = initialState, action: ActionInterface): StateInterface => {
  switch (action.type) {
    case Constants.GLOBAL_EVENTS_SAVE_LIST_SUCCESS:
    {
      const request: string = action.payload?.request;
      let requests = !!state.requests ? {...state.requests} : {};
      const count: number = !!action.payload?.count ? action.payload?.count : 0;
      const events: EventInterface[] = !!action.payload?.events ? action.payload?.events : [];

      requests[request] = {
        count: count,
        events: [...events]
      };

      const notificationsEventsCount: number = action.payload?.notificationsEventsCount ? 
        action.payload?.notificationsEventsCount : state.notificationsEventsCount;
      const unfinishedTasksEventsCount: number = action.payload?.unfinishedTasksEventsCount ? 
        action.payload?.unfinishedTasksEventsCount : state.unfinishedTasksEventsCount;
      const activitiesEventsCount: number = action.payload?.activitiesEventsCount ? 
        action.payload?.activitiesEventsCount : state.activitiesEventsCount;

      return {
        ...state,
        requests: {...requests},
        notificationsEventsCount: String(notificationsEventsCount),
        unfinishedTasksEventsCount: String(unfinishedTasksEventsCount),
        activitiesEventsCount: String(activitiesEventsCount),
        requestsOutdated: false
      };
    }

    case Constants.GLOBAL_REMINDERS_SAVE_LIST_SUCCESS:
    {
      const reminders: EventInterface[] = !!action.payload?.reminders ? action.payload?.reminders : [];

      return {
        ...state,
        reminders: reminders
      };
    }

    case Constants.GLOBAL_EVENTS_LIST_OUTDATE_REQUESTS:
    {
      const reminders = state.reminders;

      return {
        ...initialState,
        notificationsEventsCount: state.notificationsEventsCount,
        unfinishedTasksEventsCount: state.unfinishedTasksEventsCount,
        activitiesEventsCount: state.activitiesEventsCount,
        reminders: reminders,
        requestsOutdated: true
      };
    }

    case Constants.GLOBAL_CONVERSATIONS_LIST_OUTDATE_REQUESTS:
      {
        return {
          ...initialState,
          requestsOutdated: true
        };
      }

    case Constants.GLOBAL_EVENTS_SAVE_LIST_CLEAR:
    {
      return {
        ...initialState
      };
    }

    case Constants.AUTH_SIGNOUT:
      return {
        ...initialState
      };

    default:
      return state;
  }
};
